/* =====================================================
   VAPELAND — SHOPIFY THEME JS
   Pixel-perfect match to React site behaviour
   ===================================================== */

document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE MENU ──────────────────────────────────────
  var menuToggle = document.getElementById('menu-toggle');
  var mobileNav  = document.getElementById('mobile-nav');
  var iconMenu   = document.getElementById('icon-menu');
  var iconClose  = document.getElementById('icon-close');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      if (iconMenu)  iconMenu.style.display  = isOpen ? 'none'   : '';
      if (iconClose) iconClose.style.display = isOpen ? ''       : 'none';
    });
  }

  // ── STORE STATUS — America/Toronto (matches storeHours.ts) ──
  var HOURS = [
    { open: 10, close: 18 }, // Lundi   (JS Sun=0 → mapped below)
    { open: 10, close: 18 }, // Mardi
    { open: 10, close: 18 }, // Mercredi
    { open: 10, close: 21 }, // Jeudi
    { open: 10, close: 21 }, // Vendredi
    { open: 10, close: 17 }, // Samedi
    { open: 12, close: 17 }, // Dimanche
  ];

  function getEasternTime() {
    var now = new Date();
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Toronto',
      weekday: 'short',
      hour:    'numeric',
      minute:  'numeric',
      hour12:  false
    }).formatToParts(now);
    var map  = { Mon:0, Tue:1, Wed:2, Thu:3, Fri:4, Sat:5, Sun:6 };
    var wday = (parts.find(function(p){ return p.type==='weekday'; }) || {}).value || 'Mon';
    var hr   = parseInt((parts.find(function(p){ return p.type==='hour'; }) || {}).value || '0', 10);
    var min  = parseInt((parts.find(function(p){ return p.type==='minute'; }) || {}).value || '0', 10);
    return { dayIdx: map[wday] !== undefined ? map[wday] : 0, hour: hr, minute: min };
  }

  function computeStatus() {
    var t      = getEasternTime();
    var today  = HOURS[t.dayIdx];
    var nowM   = t.hour * 60 + t.minute;
    var openM  = today.open  * 60;
    var closeM = today.close * 60;
    var next   = HOURS[(t.dayIdx + 1) % 7];

    if (nowM >= openM && nowM < closeM) {
      return { open: true,  label: 'Ouvert maintenant',   sub: 'Ferme à ' + today.close + 'h', color: '#22c55e', icon: '🟢' };
    } else if (nowM < openM) {
      return { open: false, label: "Fermé pour l'instant", sub: 'Ouvre à ' + today.open + 'h',   color: '#f59e0b', icon: '🟡' };
    } else {
      return { open: false, label: 'Fermé maintenant',    sub: 'Ouvre demain à ' + next.open + 'h', color: '#ef4444', icon: '🔴' };
    }
  }

  var status = computeStatus();

  // Update highlights bar store status item (by IDs)
  var hlLabel = document.getElementById('status-label');
  var hlSub   = document.getElementById('status-sub');
  var hlIcon  = document.getElementById('status-icon');
  if (hlLabel) hlLabel.textContent = status.label;
  if (hlSub)   hlSub.textContent   = status.sub;
  if (hlIcon) {
    hlIcon.textContent = status.icon;
    hlIcon.style.background = status.color + '18';
  }

  // Update any [data-store-status] elements (store-info section)
  document.querySelectorAll('[data-store-status]').forEach(function (el) {
    var dot     = el.querySelector('.status-dot');
    var labelEl = el.querySelector('.status-label');
    var subEl   = el.querySelector('.status-sub');
    if (dot) {
      dot.className = 'status-dot status-dot--' + (status.open ? 'open' : (status.color === '#f59e0b' ? 'soon' : 'closed'));
      dot.style.background = status.color;
      dot.style.boxShadow  = status.open ? '0 0 6px ' + status.color : 'none';
    }
    if (labelEl) { labelEl.textContent = status.label; labelEl.style.color = status.color; }
    if (subEl)   subEl.textContent = status.sub;
  });

  // Highlight today's hours row
  document.querySelectorAll('[data-hours-row]').forEach(function (row, i) {
    if (i === getEasternTime().dayIdx) {
      row.style.background   = status.color + '12';
      row.style.borderColor  = status.color + '30';
      var badge = row.querySelector('[data-hours-status]');
      if (badge) {
        badge.textContent = status.open ? 'OUVERT' : 'FERMÉ';
        badge.style.background = status.color + '20';
        badge.style.color = status.color;
      }
    }
  });

  // ── QUANTITY BUTTONS ─────────────────────────────────
  document.querySelectorAll('.qty-wrap').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus  = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });

  // ── FAQ ACCORDION ────────────────────────────────────
  document.querySelectorAll('[data-faq-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body   = btn.nextElementSibling;
      var isOpen = body && body.style.display === 'block';
      document.querySelectorAll('[data-faq-body]').forEach(function (b) { b.style.display = 'none'; });
      document.querySelectorAll('[data-faq-btn] .faq-chevron').forEach(function (c) { c.style.transform = ''; });
      if (!isOpen && body) {
        body.style.display = 'block';
        var chev = btn.querySelector('.faq-chevron');
        if (chev) chev.style.transform = 'rotate(180deg)';
      }
    });
  });

  // ── CONTACT TABS ──────────────────────────────────────
  document.querySelectorAll('.contact-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.tab;
      document.querySelectorAll('.contact-tab').forEach(function (t) { t.classList.remove('active-tab'); });
      document.querySelectorAll('.contact-panel').forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active-tab');
      var panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('active');
    });
  });

  // ── AGE GATE ─────────────────────────────────────────
  var ageOverlay = document.getElementById('age-gate-overlay');
  if (ageOverlay) {
    var verified = sessionStorage.getItem('vl_age_ok') === '1';
    if (!verified) {
      ageOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    var confirmBtn = document.getElementById('age-gate-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        sessionStorage.setItem('vl_age_ok', '1');
        ageOverlay.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
  }

  // ── CART COUNT (live update) ──────────────────────────
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-cart-count').forEach(function (el) {
          el.textContent  = cart.item_count > 0 ? cart.item_count : '';
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }
  refreshCartCount();

  // Re-check after add-to-cart form submits
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      setTimeout(refreshCartCount, 800);
    });
  });

});
